module.exports = __webpack_public_path__ + "static/media/riskpic4@3x.f5fccdc8.png";